import { configureStore } from '@reduxjs/toolkit';
import { panelReducer } from '@origo/origo-components';
import { mapSlice } from '@origo/map-context';
import { authCombinedReducer } from '@origo/auth';
import delomradetypeFilterReducer from './delomradetypeFilterSlice';
import uiReducer from './uiSlice';

const store = configureStore({
    reducer: {
        panel: panelReducer,
        map: mapSlice.reducer,
        auth: authCombinedReducer,
        delomradetypeFilter: delomradetypeFilterReducer,
        ui: uiReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
